import React from 'react';
import { FiCheck, FiPlay, FiPause, FiX, FiUserPlus } from 'react-icons/fi';

const TaskActionsPanel = ({ task, onStatusChange, onReassign, isAdmin, updating }) => {
  const getAvailableStatusActions = () => {
    const currentStatus = task.status;
    const actions = [];

    switch (currentStatus) {
      case 'pending':
        actions.push({ status: 'in_progress', label: 'Start Task', icon: FiPlay, color: 'blue' });
        if (isAdmin) {
          actions.push({ status: 'cancelled', label: 'Cancel', icon: FiX, color: 'red' });
        }
        break;
      case 'in_progress':
        actions.push({ status: 'completed', label: 'Complete', icon: FiCheck, color: 'green' });
        if (isAdmin) {
          actions.push({ status: 'on_hold', label: 'Put On Hold', icon: FiPause, color: 'yellow' });
          actions.push({ status: 'cancelled', label: 'Cancel', icon: FiX, color: 'red' });
        }
        break;
      case 'on_hold':
        if (isAdmin) {
          actions.push({ status: 'in_progress', label: 'Resume', icon: FiPlay, color: 'blue' });
          actions.push({ status: 'cancelled', label: 'Cancel', icon: FiX, color: 'red' });
        }
        break;
      case 'completed':
        if (isAdmin) {
          actions.push({ status: 'closed', label: 'Close', icon: FiCheck, color: 'gray' });
        }
        break;
      default:
        break;
    }

    return actions;
  };

  const statusActions = getAvailableStatusActions();

  const getColorClasses = (color) => {
    const classes = {
      blue: 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500',
      green: 'bg-green-600 hover:bg-green-700 focus:ring-green-500',
      yellow: 'bg-accent-gold hover:bg-accent-goldDark focus:ring-accent-gold',
      red: 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
      gray: 'bg-gray-600 hover:bg-gray-700 focus:ring-gray-500'
    };
    return classes[color] || classes.blue;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Actions</h2>

      <div className="space-y-3">
        {/* Status Change Actions */}
        {statusActions.length > 0 && (
          <>
            <div className="text-sm font-medium text-gray-700 mb-2">Update Status</div>
            {statusActions.map((action) => {
              const Icon = action.icon;
              return (
                <button
                  key={action.status}
                  onClick={() => onStatusChange(action.status)}
                  disabled={updating}
                  className={`w-full inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${getColorClasses(action.color)} focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                  <Icon className="mr-2 h-4 w-4" />
                  {action.label}
                </button>
              );
            })}
          </>
        )}

        {/* Reassign Action */}
        {isAdmin && !['completed', 'cancelled', 'closed'].includes(task.status) && (
          <>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="text-sm font-medium text-gray-700 mb-2">Reassign Task</div>
              <button
                onClick={onReassign}
                disabled={updating}
                className="w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-gold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <FiUserPlus className="mr-2 h-4 w-4" />
                Reassign to Another User
              </button>
            </div>
          </>
        )}

        {/* Task Status Info */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="text-xs text-gray-500 space-y-1">
            <div>
              <span className="font-medium">Current Status:</span>{' '}
              <span className="capitalize">{task.status.replace('_', ' ')}</span>
            </div>
            <div>
              <span className="font-medium">Priority:</span>{' '}
              <span className="capitalize">{task.priority}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskActionsPanel;
